(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'GoogleEnhancedEcommerce';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googleEnhancedEcommerce", TrackingModel);
        var gAnalyticsCode = TrackingModel.GoogleAnalyticsCode;
        var CanTrack = LhApp.Function.Tracking.canTrack('statisticCookies');

        if (!Tracker || !gAnalyticsCode)
            return;

        var _trackQueue = []; // store ga tracking info until consent ready

        var _cartAddResponses = []; // holds a response for every cart add action. 
        var _currentCartModel;
        var _isUserSelectedProduct;

        var _batchSize = parseInt(Tracker.Properties.EnhancedEcommerceBatchProductsAmount || '15');
        var _maxCategoryLength = parseInt(Tracker.Properties.EnhancedEcommerceMaxCategoryLength || '100');
        var _maxTitleLength = parseInt(Tracker.Properties.EnhancedEcommerceMaxTitleLength || '100');

        var removeFromList = true; // Amazon recommendation cookie

        var analyticsBatch = {

            getCookie: function (cid) {
                cid = Cookies.get(cid);
                if (!cid) return '';
                cid = cid.split('.');
                cid = cid[2] + '.' + cid[3];
                return cid;
            },

            add: function () {

                var cid = this.getCookie('_ga');
                var gid = this.getCookie('_gid');
                var tid = gAnalyticsCode;

                var prArg = arguments[3];
                var prodData = '';

                Object.values(prArg).forEach(function (prod, index) {

                    var i = index + 1;

                    prodData += '&pr' + i + 'id=' + encodeURIComponent(prod.id);
                    prodData += '&pr' + i + 'nm=' + encodeURIComponent(prod.name);
                    prodData += '&pr' + i + 'pr=' + encodeURIComponent(prod.price);

                    if (prod.brand)
                        prodData += '&pr' + i + 'br=' + encodeURIComponent(prod.brand);

                    if (prod.category)
                        prodData += '&pr' + i + 'ca=' + encodeURIComponent(prod.category);

                    if (prod.variant)
                        prodData += '&pr' + i + 'va=' + encodeURIComponent(prod.variant);

                    if (prod.dimension1)
                        prodData += '&pr' + i + 'cd1=' + encodeURIComponent(prod.dimension1);

                    if (prod.position)
                        prodData += '&pr' + i + 'ps=' + encodeURIComponent(prod.position);

                    if (prod.quantity)
                        prodData += '&pr' + i + 'qt=' + encodeURIComponent(prod.quantity);
                });

                var requiredData =
                    'v=1' +
                    '&tid=' + tid +
                    '&cid=' + cid +
                    '&t=pageview' +
                    '&dl=' + encodeURIComponent(window.location.href) +
                    '&de=UTF-8' +
                    '&dt=' + encodeURIComponent(document.title) +
                    '&dh=' + encodeURIComponent(window.location.hostname) +
                    '&ti=' + encodeURIComponent(arguments[2].id) +
                    '&pa=' + encodeURIComponent(arguments[1]);

                var additionalData =
                    '&_gid=' + gid +
                    '&ta=' + encodeURIComponent(arguments[2].affiliation) +
                    '&tr=' + encodeURIComponent(arguments[2].revenue) +
                    '&tt=' + encodeURIComponent(arguments[2].tax) +
                    '&ts=' + encodeURIComponent(arguments[2].shipping);

                if (typeof (this.data) == 'undefined') {
                    this.data = requiredData + additionalData + prodData;
                } else {
                    this.data += '\r\n' + requiredData + prodData;
                }

            },

            send: function () {

                if (!CanTrack) return;

                var settings = {
                    "async": true,
                    "crossDomain": true,
                    "url": "https://www.google-analytics.com/batch",
                    "method": "POST",
                    "data": this.data
                }

                $.ajax(settings);

            }

        };

        function CleanUpTrackingProduct(product) {
            if (!product)
                return product;

            if (product.hasOwnProperty('variant') && !product.variant)
                delete product.variant;
            if (product.hasOwnProperty('dimension1') && !product.dimension1)
                delete product.dimension1;

            return product;
        }

        function Track() {
            if (!(/^\s*(true|yes|1)\s*$/i).test(Tracker.Properties.TrackUsingGA || 'true')) return;

            while (_trackQueue.length > 0) {
                //if tracking fails exit without changing the queue;
                if (!LhApp.Function.Tracking.ga.apply(null, _trackQueue[0]))
                    break;

                //else remove item at position 0 from queue
                _trackQueue.shift();
            }

            if (LhApp.Function.Tracking.ga.apply(null, arguments)) {
                _trackQueue = []; // if for any reason we managed to tracke current event then clear all previous
                return;
            }

            //if tracking fails unlike dataLayer tracking here we can store tracking info. when consent is ready we can 'replay' tracking
            _trackQueue.push(arguments);
        }

        function DataLayerPush() {
            if (!(/^\s*(true|yes|1)\s*$/i).test(Tracker.Properties.PopulateDataLayer || 'false')) return;

            if (!arguments) return;

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push(arguments[0]);
        }

        Init();

        function Init() {
            //if initialized exit
            if (Tracker._Initialized) return;
            Tracker._Initialized = true;

            Track('require', 'ec');

            //TRACK product list 
            if ((TrackingModel.IsHomePage || TrackingModel.IsProductListPage || TrackingModel.IsAllOtherPages) && TrackingModel.ProductListsData) {
                var products = _.flatten(_.toArray(TrackingModel.ProductListsData));
                var ecImpressions = [];
                while (products.length > 0) {
                    var batch = products.slice(0, _batchSize);
                    products.splice(0, _batchSize);

                    for (var i in batch) {
                        var product = batch[i];

                        var ecImpression = CleanUpTrackingProduct({
                            id: product.ProductId,
                            name: (product.Name || '').substring(0, _maxTitleLength),
                            price: product.PriceWithoutVatN,
                            brand: product.Brand,
                            category: (product.Category || '').substring(0, _maxCategoryLength),
                            position: product.Position,
                            variant: product.DefaultColor,
                            list: product.List
                        });
                        ecImpressions.push(ecImpression);

                        Track("ec:addImpression", ecImpression);
                    }

                    Track('send', 'event', 'productlist', 'sendImpressions', 'productlistdata', '111111', { nonInteraction: 1 });
                }

                Track("send", "pageview");

                //GTM         
                DataLayerPush({
                    'ecommerce': {
                        'impressions': ecImpressions
                    }
                });
            }

            //TRACK product details
            if (TrackingModel.IsProductDetailsPage) {

                var products = _.flatten(_.toArray(TrackingModel.ProductListsData));
                var ecImpressions = [];
                while (products.length > 0) {
                    var batch = products.slice(0, _batchSize);
                    products.splice(0, _batchSize);

                    for (var i in batch) {
                        var product = batch[i];
                        var ecImpression = CleanUpTrackingProduct({
                            id: product.ProductId,
                            name: (product.Name || '').substring(0, _maxTitleLength),
                            price: product.PriceWithoutVatN,
                            brand: product.Brand,
                            category: (product.Category || '').substring(0, _maxCategoryLength),
                            position: product.Position,
                            variant: product.DefaultColor,
                            list: product.List
                        });
                        Track("ec:addImpression", ecImpression);
                        ecImpressions.push(ecImpression);
                    }

                    Track('send', 'event', 'productDetails', 'sendImpressions', 'productlistdata', '111111', { nonInteraction: 1 });
                }

                var ecAddProduct;
                if (TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                    var product = TrackingModel.ProductData[0];
                    ecAddProduct = CleanUpTrackingProduct({
                        id: product.ProductId,
                        name: (product.Name || '').substring(0, _maxTitleLength),
                        price: product.PriceWithoutVatN,
                        brand: product.Brand,
                        variant: product.DefaultColor,
                        category: (product.Category || '').substring(0, _maxCategoryLength)
                    });

                    Track("ec:addProduct", ecAddProduct);
                }

                Track("ec:setAction", "detail");
                Track("send", "pageview");

                //GTM
                DataLayerPush({
                    'ecommerce': {
                        'detail': {
                            'products': [ecAddProduct]
                        },
                        'impressions': ecImpressions
                    }
                });

                $(window).on('beforeunload', function () {
                    if (removeFromList) {
                        Cookies.remove('listFrom');
                    }
                });
            }

            //TRACK Amazon Recommendation in PD and cart page
            if (TrackingModel.IsProductDetailsPage || TrackingModel.IsCartPage) {

                var amazonSuggestedProductsList = $('.amazon-list-related-products');

                if (amazonSuggestedProductsList.length > 0) { // in case that suggested products is disabled

                    if ($('.x-product-box', amazonSuggestedProductsList).length > 0) {

                        var amazonListCode = amazonSuggestedProductsList.closest('.x-product-list').attr('data-trackinglist-type');
                        var listName = (amazonListCode === 'amazon-recom-pd') ? 'Amazon Recommendation PD'
                            : (amazonListCode === 'amazon-recom-cart') ? 'Amazon Recommendation Cart' : '';

                        $('.x-product-box', amazonSuggestedProductsList).each(function (index) {
                            var productBox = $(this);
                            var productId = productBox.attr('data-variantid');
                            var title = $('.heading a', productBox).text();
                            var addToCart = $('.js-add-to-cart', productBox);

                            // On load
                            Track('ec:addProduct', {
                                'id': productId,
                                'name': title,
                                'list': listName,
                                'position': index + 1
                            });

                            Track("ec:addImpression", {
                                'id': productId,
                                'name': title,
                                'list': listName,
                                'position': index + 1
                            });

                            Track('ec:addPromo', {
                                'id': 'AR',
                                'name': listName,
                                'creative': productId,
                                'position': index + 1
                            });

                            // Send the promo view with an event.         
                            Track('ec:setAction', 'detail');

                            // On click
                            productBox.on('click', function () {

                                Track('ec:addPromo', {
                                    'id': 'AR',
                                    'name': listName,
                                    'creative': productId,
                                    'position': index + 1
                                });

                                // Send the promo_click action with an event.
                                Track('ec:setAction', 'promo_click');
                                Track('send', 'event', 'Internal Promotions', 'click', listName);

                                Track('ec:addProduct', {
                                    'id': productId,
                                    'name': title,
                                    'list': listName,
                                    'position': index + 1
                                });

                                Cookies.set("listFrom", listName, { samesite: 'Lax' });
                                removeFromList = false;

                                // Send the product click in a product list
                                Track('ec:setAction', 'click', { list: listName });
                                Track('send', 'event', 'enhanced ecommerce', 'click', productId);

                            });

                            // On click to addToCart Btn
                            addToCart.on('click', function () {

                                Track('ec:addProduct', {
                                    'id': productId,
                                    'name': title,
                                    'list': listName,
                                    'position': index + 1
                                });

                                // Send the product click in a product list
                                Track('ec:setAction', 'click', { list: listName });
                                Track('send', 'event', 'enhanced ecommerce', 'click', productId);
                            })
                        });

                        Track("send", "pageview");
                    }
                }

            }

            //TRACK checkout
            if (TrackingModel.IsCheckoutPage && TrackingModel.CartProductsData) {
                var products = TrackingModel.CartProductsData;
                var ecAddProducts = [];
                var idx = 0;
                while (products.length > 0) {
                    var batch = products.slice(0, _batchSize);
                    products.splice(0, _batchSize);

                    for (var i in batch) {
                        var product = batch[i];

                        idx += 1;
                        var ecAddProduct = CleanUpTrackingProduct({
                            id: product.ProductId,
                            name: (product.Name || '').substring(0, _maxTitleLength),
                            price: product.PriceWithoutVatN,
                            brand: product.Manufacturer,
                            category: (product.Category || '').substring(0, _maxCategoryLength),
                            variant: product.Color,
                            dimension1: product.Size,
                            position: idx,
                            quantity: product.Quantity
                        });
                        ecAddProducts.push(ecAddProduct);
                        Track("ec:addProduct", ecAddProduct);
                    }
                }

                Track("ec:setAction", "checkout");
                Track("send", "pageview");

                //GTM
                DataLayerPush({
                    'event': 'checkout',
                    'ecommerce': {
                        'checkout': {
                            'actionField': { 'step': 1 },
                            'products': ecAddProducts
                        }
                    }
                });
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var products = TrackingModel.CartProductsData;
                var ecAddProducts = [];
                var ecActionField;
                var idx = 0;

                while (products.length > 0) {
                    var batch = products.slice(0, _batchSize);
                    products.splice(0, _batchSize);

                    var currentBatchProducts = [];

                    for (var i in batch) {
                        var product = batch[i];

                        idx += 1;
                        var ecAddProduct = CleanUpTrackingProduct({
                            id: product.ProductId,
                            name: (product.Name || '').substring(0, _maxTitleLength),
                            price: product.PriceWithoutVatN,
                            brand: product.Brand,
                            category: (product.Category || '').substring(0, _maxCategoryLength),
                            variant: product.Color,
                            dimension1: product.Size,
                            position: idx,
                            quantity: product.Quantity
                        });
                        ecAddProducts.push(ecAddProduct);
                        currentBatchProducts.push(ecAddProduct);
                    }
                    ecActionField = {
                        id: TrackingModel.Order.Id,
                        affiliation: "Online Store",
                        revenue: TrackingModel.Order.ProductsCostWithouVatN,
                        tax: TrackingModel.Order.VatCostN,
                        shipping: TrackingModel.Order.ShippingCostWithoutVatN
                    };

                    analyticsBatch.add("ec:setAction", "purchase", ecActionField, currentBatchProducts); // Generate data for analytics batch
                }

                analyticsBatch.send(); // Send all data from all batches to analytics

                //GTM
                DataLayerPush({
                    'ecommerce': {
                        'purchase': {
                            'actionField': ecActionField,
                            'products': ecAddProducts
                        }
                    }
                });
            }

            //TRACK checkout step changes
            if (TrackingModel.IsCheckoutPage && TrackingModel.CartProductsData) {
                var ready = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        //register events once
                        if (!ready) {
                            ready = true;

                            var smScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                            smScope.$watch('PaymentMethod.Current', function (current, previous) {
                                if (!current || (previous && current.Id != previous.Id))
                                    return;

                                Track("ec:setAction", "checkout_option", {
                                    "step": 1,
                                    "option": current.Name
                                });

                                //GTM
                                DataLayerPush({
                                    'event': 'checkoutOption',
                                    'ecommerce': {
                                        'checkout_option': {
                                            'actionField': { 'step': 1, 'option': current.Name },
                                        }
                                    }
                                });
                            });
                        }
                    });
                }
            }
        }

        // IMPORTANT execute this scripts in all other pages except checkout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //wait for consents update and initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                Track();//trigger empty of tracking queue
            });

            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {

                var amazonListCode = $(envelope.sender).closest('.x-product-list').attr('data-trackinglist-type');
                var listName = (amazonListCode === 'amazon-recom-pd') ? 'Amazon Recommendation PD'
                    : (amazonListCode === 'amazon-recom-cart') ? 'Amazon Recommendation Cart' : '';

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty),
                    listName
                });
            });

            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_add', function (envelope) {

                var cartModel = envelope.message.data.Cart;
                //var _cartAddResponses = _CartAddResponses.slice();

                var pAddResponse = _cartAddResponses.shift();
                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var pCartItemModel = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (pCartItemModel) {
                        var product = pCartItemModel;
                        var ecAddProduct;
                        // find source list and position of the item in that list
                        var list = '';
                        var position = 0;
                        if (TrackingModel.ProductData && TrackingModel.ProductData[0] && TrackingModel.ProductData[0].ProductId == p.ProductId) // product details
                        {
                            list = Cookies.get('listFrom');
                            position = 1;
                        }
                        else if (p.listName && p.listName !== '') {
                            list = p.listName;
                            position = 1;
                        }
                        else if (TrackingModel.ProductListsData)
                            for (var listName in TrackingModel.ProductListsData) {
                                for (var item in TrackingModel.ProductListsData[listName]) {
                                    if (TrackingModel.ProductListsData[listName][item].ProductId == p.ProductId) {
                                        list = listName;
                                        position = TrackingModel.ProductListsData[listName][item].Position;
                                        break;
                                    }
                                }
                                if (position > 0)
                                    break;
                            }
                        ecAddProduct = CleanUpTrackingProduct({
                            id: product.ProductId,
                            name: (product.Title || '').substring(0, _maxTitleLength),
                            price: product.Prices.PriceWithoutVatN,
                            brand: product.Manufacturer,
                            category: (product.Category || '').substring(0, _maxCategoryLength),
                            variant: product.color,
                            dimension1: product.size,
                            position: position, // must be changed. 0 if is product of a product details
                            quantity: pAddResponse.Quantity,
                            list: list
                        });

                        Track("ec:addProduct", ecAddProduct);
                        Track("ec:setAction", "add", { list: list });
                        Track("send", "event", "enhanced ecommerce", "click", "add to Cart");
                        Cookies.remove('listFrom');
                    }

                    //GTM
                    DataLayerPush({
                        'event': 'addToCart',
                        'ecommerce': {
                            'add': {                                // 'add' actionFieldObject measures.
                                'actionField': { 'list': list },      // Optional list property.
                                'products': [ecAddProduct]
                            }
                        }
                    });

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);

            });

            //TRACK cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                var hasCartItemChanges = envelope.message.data.Cart.Items.length > 0; //keep track of possible cart changes
                if (_currentCartModel && _currentCartModel.Items && _currentCartModel.Items.length > 0) {
                    hasCartItemChanges = JSON.stringify(_currentCartModel.Items) !== JSON.stringify(envelope.message.data.Cart.Items);
                }

                //keep variable of cart items model synced to rela data in order to use it during item deletion
                _currentCartModel = JSON.parse(JSON.stringify(envelope.message.data.Cart));//clone
                if (TrackingModel.IsCartPage) {
                    var ecAddProducts = [];

                    var idx = 0;
                    var products = JSON.parse(JSON.stringify(envelope.message.data.Cart.Items));
                    while (products.length > 0) {
                        var batch = products.slice(0, _batchSize);
                        products.splice(0, _batchSize);

                        for (var i in batch) {
                            var product = batch[i];
                            idx += 1;

                            var color;
                            var size;

                            for (var dim = 0; dim < product.Dimensions.length; dim++) {
                                var dimension = product.Dimensions[dim];
                                if (dimension.Id == product.ColorId)
                                    color = dimension.Name;
                                if (dimension.Id == product.SizeId)
                                    size = dimension.Name;
                            }

                            var ecAddProduct = CleanUpTrackingProduct({
                                id: product.ProductId,
                                name: (product.Title || '').substring(0, _maxTitleLength),
                                price: product.Prices.PriceWithoutVatN,
                                brand: product.Manufacturer,
                                category: (product.Category || '').substring(0, _maxCategoryLength),
                                variant: color,
                                dimension1: size,
                                position: idx,
                                quantity: product.Quantity
                            });
                            ecAddProducts.push(ecAddProduct);

                            Track("ec:addProduct", ecAddProduct);

                        }
                        Track('send', 'event', 'cart', 'addProducts', 'cartdata', '222222', { nonInteraction: 1 });
                    }

                    Track("send", "pageview", "shoppingCart");

                    //GTM - in the new implementation with dataLayer nothing to track
                }
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });

            //TRACK REMOVE ITEM FROM CART
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, TrackingScriptName, function (envelope) {

                if (!_currentCartModel)
                    return;

                var pCartItemModel = _currentCartModel.Items.filter(function (i) {
                    return i.Id == envelope.message.data.id;
                })[0];

                var idx = _currentCartModel.Items.findIndex(function (i) {
                    return i.Id == envelope.message.data.id;
                })

                if (pCartItemModel) {
                    var product = pCartItemModel;
                    var ecAddProduct = CleanUpTrackingProduct({
                        id: product.ProductId,
                        name: (product.Title || '').substring(0, _maxTitleLength),
                        price: product.Price,
                        brand: product.Brand,
                        category: (product.Category || '').substring(0, _maxCategoryLength),
                        variant: product.color,
                        dimension1: product.size,
                        position: idx ? idx + 1 : 1,
                        quantity: pCartItemModel.Quantity
                    });

                    Track("ec:addProduct", ecAddProduct);


                    Track("ec:setAction", "remove");
                    Track("send", "event", "cart", "click", "removeFromCart");

                    //GTM
                    DataLayerPush({
                        'event': 'removeFromCart',
                        'ecommerce': {
                            'remove': {                                // 'add' actionFieldObject measures.
                                'products': [ecAddProduct]
                            }
                        }
                    });
                }
            });

        }
    });
})();
